import React, { useEffect, useState } from "react";
import { Modal, ModalSize } from "components/notifications";
import PropTypes from "prop-types";
import { ListingTable } from "components/listing";
import { FormTextInput } from "components/form-fields";

export function EntitlementKeyModal({
    isOpen = false,
    onClose = () => {},
    entitlements = []
}) {
    const headers = ["category", "type", "description"];
    const [tableRows, setTableRows] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        setTableRows(
            entitlements.map((entitlement) => {
                return [
                    entitlement.code,
                    entitlement.name,
                    entitlement.description,
                ];
            })
        );
    }, [entitlements]);

    useEffect(() => {
        setTableRows(
            entitlements
                .filter((entitlement) =>
                    entitlement.code
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase())
                )
                .map((entitlement) => {
                    return [
                        entitlement.code,
                        entitlement.name,
                        entitlement.description,
                    ];
                })
        );
    }, [searchTerm]);

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Entitlements"
            size={ModalSize.LARGE}
        >
            <div>
                <div className="spacer-bottom">
                    <div className="inline-items inline-items-fill">
                        <div className="inline-item">
                            <FormTextInput
                                id="entitlements-search-field"
                                icon="search"
                                placeholder="Search entitlements category"
                                onChange={(x) => setSearchTerm(x.target.value)}
                                value={searchTerm}
                                large
                                fill
                            />
                        </div>
                    </div>
                </div>
                <h2>All Entitlements</h2>

                <ListingTable
                    id="licence-checking-entitlements-key-modal"
                    headers={headers}
                    data={tableRows}
                    totalRecordCount={tableRows.length}
                    showPerPage={false}
                    loadingData={false}
                    pageable={false}
                    fixedHeight
                />
            </div>
        </Modal>
    );
}

EntitlementKeyModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    entitlements: PropTypes.array.isRequired,
};
